import React from 'react';

const TabComponent = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-200" role="tablist">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`${tab.id}-panel`}
            id={`${tab.id}-tab`}
            className={`
              whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-[#F15213] focus:ring-opacity-50
              ${activeTab === tab.id
                ? 'border-[#F15213] text-[#F15213]'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <div className="flex items-center">
              {tab.label}
              {tab.badge && (
                <span className="ml-2 px-2 py-0.5 text-xs font-medium rounded-full bg-red-100 text-red-800">
                  {tab.badge}
                </span>
              )}
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TabComponent; 